export default function ECATStatementDocumentDirective() {
  return {
    template: require('./statement-document.html'),
    scope: {
      criStatementId: '=',
      canEdit: '=',
      canDelete: '=',
      statementDocument: '=',
    },
    controller: 'ECATStatementDocumentController',
    controllerAs: 'statementDocumentVM',
    bindToController: true,
    replace: true
  };
}
